module.exports = __webpack_public_path__ + "img/3.96518104.png";